<template>
    <div class="help-widget">
        <div class="bubble">
            <h3>{{ title }}</h3>
            <p>Click the icon below to get started.</p>
        </div>
    </div>
</template>

<script>
import { sample } from 'lodash';

export default {
    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            titleVariants: [
                'We\'re here to help!',
                'Hey! We\'re here for you.',
                'Looking for some help?',
                'Need some guidance?',
                'Need Fusebox help?',
            ],
        };
    },

    computed: {
        /**
         * Return selected title variant.
         *
         * @returns {string} Selected title variant.
         */
        title() {
            return sample(this.titleVariants);
        },
    },
};
</script>
